import { request } from '@/utils/request'

// export function getInfo(){
//   return request({
//     url:`/user/info`,
//     method:'get'
//   })
// }

// export function updateUserInfo(params){
//   return request({
//     url:'user/patch',
//     method:'patch',
//     data:params
//   })
// }
export function updatePassword(params) {
  return request({
    url: `user/resetPasswordBySmsCode/${params.inputCode}`,
    method: 'get'
    // data: params,
  })
}
// 重置密码
export function updatePasswordNew() {
  return request({
    url: `/user/resetPwd`,
    method: 'get'
    // data: params,
  })
}
/**
 * 获取院校列表
 */
export function getSchoolList(params) {
  return request({
    url: `exam-institution/${params.pageNum}/${params.pageSize}`,
    method: 'post',
    data: {}
  })
}
/**
 * 获取专业列表
 */
export function getMajorList(params) {
  return request({
    url: `/exam-major/${params.pageNum}/${params.pageSize}`,
    method: 'post',
    data: params.condition
  })
}
/**
 * 学生端获取专业列表
 */
export function getMajorListNew(id) {
  return request({
    url: `exam-major/getMajorBySchoolId?schoolId=${id}`,
    method: 'get'
  })
}
/**
 * 获取科目列表
 */
export function getSubjectList(params) {
  return request({
    url: `exam-subject/${params.pageNum}/${params.pageSize}`,
    method: 'post',
    data: params.condition
  })
}

//3.1.2 获取考生基础信息
export function getInfo(id) {
  return request({
    url: `/exam-user-base/${id}`,
    method: 'get'
  })
}
//3.1.1 编辑考生
export function updateUserInfo(params) {
  return request({
    url: 'exam-user-base',
    method: 'put',
    data: params
  })
}
//3.1.3 身份证识别
export function identifyIdCardInfo(data) {
  return request({
    url: 'user/uploadIdCardIcon',
    method: 'post',
    data
  })
}
//上传人像照并识别是否是本人
export function identifyIdCardICheckIsSame(data) {
  return request({
    url: 'user/matchPortraitIcon',
    method: 'post',
    headers: {
      "Content-Type": "application/json",
    },
    data
  })
}
